import { render, staticRenderFns } from "./VendorIntroButton.vue?vue&type=template&id=0dc1d1e8&scoped=true&"
import script from "./VendorIntroButton.vue?vue&type=script&lang=js&"
export * from "./VendorIntroButton.vue?vue&type=script&lang=js&"
import style0 from "./VendorIntroButton.vue?vue&type=style&index=0&id=0dc1d1e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc1d1e8",
  null
  
)

export default component.exports